//Import Vue Select
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import close from '../../_img/icons/close.svg';

import $ from 'jquery';

function postAnswer( endpoint,data ) {
	return $.ajax({
			method: 'post',
			data: data,
			url: `${appData.root}${endpoint}`,
			headers: { 'X-WP-Nonce': appData.nonce }
		});
}

export const ReplyForm = {
    components: {
		close,
		vueDropzone: vue2Dropzone,
		vSelect
	},
    data() {
		return {
			acceptedFiles: [],
			showForm: false,
            isSubmitting: false,
			isCompleted: false,
			isSuccess: false,
			isErrored: false,
			folderId: null,
			inputs: {},
            dropzoneOptions: {
				url: 'test',
				autoProcessQueue: false,
				maxFilesize: 20,
				params: {},
				previewTemplate: this.template(),
				dictInvalidFileType: 'Filtypen er ikke tilladt og vil ikke blive uploadet',
				dictResponseError: 'Filen blev ikke uploaded succesfuldt',
				acceptedFiles: 'image/png,image/jpeg,image/gif,text/csv,application/vnd.rar,application/msword,application/pdf,'
				+'application/json,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/vnd.ms-excel.sheet.macroEnabled.12,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,'
				+'application/vnd.openxmlformats-officedocument.wordprocessingml.documen,application/zip'
			}
		}
	},

	methods: {
       template() {
			return `<div class="dz-preview dz-file-preview">
						<div class="dz-details">
							<div class="dz-filename"><span data-dz-name></span></div>
							<div class="dz-size"><span data-dz-size></span></div>
						</div>
						<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
						<div class="dz-error-message"><span data-dz-errormessage></span></div>
						<div class="dz-success-mark"><i class="fa fa-check"></i></div>
						<div class="dz-error-mark"><i class="fa fa-close"></i></div>
						<a class="dz-remove" data-dz-remove><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-trash-alt fa-w-14 fa-3x"><path fill="currentColor" d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z" class=""></path></svg></a>
					</div>
			`;
		},
        toggleReplyForm(){
			if(!this.isSubmitting){
				this.isCompleted = false
				this.isErrored = false
				this.isSuccess = false
				this.folderId = false
	           	this.showForm = !this.showForm
				this.inputs = []
				this.toggleBodyScroll(this.showForm)
			}
        },
		toggleBodyScroll(value){
			let bodyClass = 'modalOpen'

			if(this.isMobileUnit()){
				bodyClass += ' isMobile'
			}

			if(value){
				document.documentElement.className = bodyClass;
				document.body.scroll = "no";
			}else{
				document.documentElement.className = '';
				document.body.scroll = "yes";
			}
		},
		isMobileUnit(){
			let check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
			return check;
		},

		handleSubmit(submitEvent) {
            this.isSubmitting = true
			this.isErrored = false

			//Create answer in WP, get unique ID return (folder created with same name as ID)
			let answer = {}

			//Add inputs to answer array
			for (const [key, value] of Object.entries(this.inputs)) {
				answer[key] = {
					'type': 'input',
					'answer': value
				}
			}

			//Add files to answer
			var i;

			if(this.$refs.replyformDropzone){
				for (i = 0; i < this.$refs.replyformDropzone.length; i++) {
					if(this.$refs.replyformDropzone[i].getQueuedFiles().length){
						let files = []
						let queued = this.$refs.replyformDropzone[i].getQueuedFiles()

						var j;
						for (j = 0; j < queued.length; j++) {
							files.push(queued[j].name)
						}
						let id = this.$refs.replyformDropzone[i].id
						answer[id] = {
							'type': 'files',
							'files': files
						}
					}
				}
			}

			let data = {
				caseID: this.content.id,
				answer: answer
			}

			if(this.folderId){
				this.uploadFiles()
			}else{
				postAnswer('kla/v1/answer/',data)
				.done(data => {
					this.folderId = data['folderId']
					this.uploadFiles()
				})
				.fail(data => {
					this.isSubmitting = false;
					this.isErrored = true;
				});
			}
        },

		fileError(file, message, xhr){
			if(xhr){
				this.isErrored = true
			}
		},

		uploadFiles(){

			if(!this.$refs.replyformDropzone){
				this.formCompleted()
				return;
			}

			if(!this.pendingFiles()){
				this.formCompleted()
				return
			}

			var i;
			for (i = 0; i < this.$refs.replyformDropzone.length; i++) {
				//Upload files to unique location
				this.$refs.replyformDropzone[i].setOption('url',appData.root+'kla/v1/answer/'+this.folderId+'/files/')
				this.$refs.replyformDropzone[i].setOption('params',{folder: this.$refs.replyformDropzone[i].id})
				this.$refs.replyformDropzone[i].processQueue()
			}
		},

		sendingEvent (file, xhr, formData) {

		},

		fileCompleted(file, response){
			if(!response.status){
				this.isErrored = true;
			}
		},

		pendingFiles(){
			let status = false
			var i;
			for (i = 0; i < this.$refs.replyformDropzone.length; i++) {
				if(this.$refs.replyformDropzone[i].getAcceptedFiles().length){
					status = true;
					break;
				}
			}
			return status
		},

		allFilesUploaded(){
			let status = true
			var i;
			for (i = 0; i < this.$refs.replyformDropzone.length; i++) {
				if(this.$refs.replyformDropzone[i].getUploadingFiles().length){
					status = false;
					break;
				}
			}
			return status
		},

		queCompleted(){
			let allComplete = true

			if(this.isSubmitting && this.allFilesUploaded()){
				this.formCompleted()
			}
		},

		formCompleted(){
			if(!this.isErrored){
				this.isSuccess = true
				this.isCompleted = true
			}

			this.isSubmitting = false
	}
	},
};



// WEBPACK FOOTER //
// ./assets/_js/mixins/reply-form.js